<template>
  <div class="operator-message-button_block">
    <!--  入金情報が入力されていない場合  -->
    <template v-if="!isStripeAccountFull">
      <router-link v-if="customClaim.isOwner" class="yellow-ellipse_button" :to="{name: 'PaymentTop'}">
        入金情報を登録
      </router-link>
      <div v-if="!customClaim.isOwner" class="inactive-rectangle_button">
        オーナーが入金情報を登録する必要があります
      </div>
    </template>

    <!--  入金情報が入力されている場合  -->
    <template v-else>
      <button v-if="isMeeting" class="yellow-ellipse_button" @click="accept()">
        正式に依頼を受ける
      </button>

      <div v-if="isWaitingForPayment" class="purple-ellipse_button">
        クライアントの支払いを待っています
      </div>

      <router-link v-if="isWaiting" class="orange-ellipse_button"
                   :to="{name: 'TempWorkDetail', params: {matchingId: matching.id}}">
        案件の変更依頼を確認する
      </router-link>

      <button v-if="isWorking" class="yellow-ellipse_button" @click="complete()">
        納品完了・検査を依頼する
      </button>

      <div v-if="isInspecting" class="purple-ellipse_button">
        検査中
      </div>

      <router-link v-if="isCompleting" :to="{name: 'CreatingClientScore'}" class="purple-ellipse_button">
        クライアントを評価する
      </router-link>
    </template>
  </div>
</template>

<script>
  import STATUSES from "@/assets/js/constants/statuses";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";
  import {mapGetters} from "vuex";

  export default {
    name: "OperatorMessageButtonBlock",

    mixins: [caller],

    props: {
      matching: {
        type: Object,
        required: true
      },
      operatorStripe: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        hasPushed: false,
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid', customClaim: 'auth/customClaim'}),

      isStripeAccountFull() {
        console.log(this.operatorStripe.accountId)
        return this.operatorStripe.accountId && this.operatorStripe.bankId
          && ((this.operatorStripe.companyId && this.operatorStripe.personId) || this.operatorStripe.individualId)
      },

      isMeeting() {
        return (this.matching.status === STATUSES.MEETING.name && !this.hasPushed);
      },

      isWaitingForPayment() {
        return (this.matching.status === STATUSES.MEETING.name && this.hasPushed)
          || (this.matching.status === STATUSES.WAITING_FOR_PAYMENT.name);
      },

      isWaiting() {
        return (this.matching.status === STATUSES.WAITING.name);
      },

      isWorking() {
        return (this.matching.status === STATUSES.WORKING.name && !this.hasPushed);
      },

      isInspecting() {
        return (this.matching.status === STATUSES.WORKING.name && this.hasPushed)
          || (this.matching.status === STATUSES.INSPECTION.name);
      },

      isCompleting() {
        return (this.matching.status === STATUSES.COMPLETION.name);
      }
    },

    beforeCreate() {
      Object.assign(this, {STATUSES});
    },

    methods: {
      async accept() {
        const params = {matchingId: this.matching.id};
        await this.callFunction(
          'startWorkingMatching',
          params
        ).then(() => {
          this.showSuccessMessage('クライアントからの支払いをお待ちください。');
          this.hasPushed = true;
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      async complete() {
        const params = {matchingId: this.matching.id, userId: this.uid};
        await this.callFunction(
          'completeMatching',
          params
        ).then(() => {
          this.showSuccessMessage('検収を依頼しました。');
          this.hasPushed = true;
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .operator-message-button_block {
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 100%;

    > .orange-ellipse_button, .yellow-ellipse_button, .purple-ellipse_button, .inactive-rectangle_button {
      margin: 1rem 0;
      width: 80%;
    }
  }
</style>